import { NextSeo } from "next-seo";
import HiddenNav from "@/components/hiddenNav";
import Link from "@/components/link/Link";
import {
  weekOptions,
  playoffWeeksGroup,
} from "@/components/schedule/filter/constants";
import NavContainer from "@/components/sitemap/NavContainer";
import Tabs from "@/components/Tabs";
import {
  SITE_MAP_SCORES_SELECTED,
  SITE_MAP_MODULE,
} from "@/constants/amplitude";
import { SEO, getNflScoresUrlWeek } from "@/constants/seo";
import {
  SITEMAP_MENU_OPTIONS,
  SITEMAP_MOBILE_MENU_OPTIONS,
} from "@/constants/sitemap";
import useSitemapNav from "@/utils/hooks/useSitemapNav";
import styles from "./sitemap.module.scss";

export default function NFLScoresSitemap() {
  const { mobileOption, mobileSelect, tabSelect, logAmplitudeEvent, selected } =
    useSitemapNav("nfl-scores");

  // combine regular season weeks (1-18) and playoff weeks (19-22)
  const allWeeks = [...weekOptions, ...playoffWeeksGroup[0].options];

  return (
    <div className={styles.container}>
      <HiddenNav links={SITEMAP_MOBILE_MENU_OPTIONS} />
      <NextSeo
        title="Sitemap"
        canonical={`${SEO.FANDUEL_URL_RESEARCH}/sitemap/nfl-scores`}
      />
      <NavContainer mobileOption={mobileOption} mobileSelect={mobileSelect} />
      <div className={styles.sitemapSearchArea}>
        <div className={styles.timeRangeTabs}>
          <Tabs
            dataTestId="sports-tabs"
            items={SITEMAP_MENU_OPTIONS}
            selected={selected}
            setSelected={tabSelect}
          />
        </div>
        <div className={styles.matchups}>
          {allWeeks.map((week) => (
            <p key={week.value} className={styles.week}>
              <Link
                next
                onClick={() =>
                  logAmplitudeEvent(SITE_MAP_SCORES_SELECTED, {
                    Module: SITE_MAP_MODULE,
                    "Item Selected": week.value,
                  })
                }
                href={getNflScoresUrlWeek(Number.parseInt(week.value, 10))}
              >
                {week.label}
              </Link>
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
